import React, { FC } from 'react';
import { MotifModalBody } from '@ey-xd/motif-react';

type ModalBodyProps = {
    style?: any;
    className?: string;
    children?: React.ReactNode;
};
const ModalBody: FC<ModalBodyProps> = ({ style, className, ...other }: ModalBodyProps) => (
    <MotifModalBody style={style} className={className} {...other} />
);
export default ModalBody;
